import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import OpeningCard from "./OpeningCard";
import openingsData from "../../data/open-projects.json";

const Section = styled.section`
  padding: 32px 0 64px;
  background: var(--nd-black);
`;

const Kicker = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  margin: 0 0 16px;
`;

const Heading = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 32px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.01em;
  line-height: 1.1;
  margin: 0 0 12px;
  @media (max-width: 768px) { font-size: 24px; }
`;

const Sub = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0 0 32px;
  max-width: 640px;
`;

const Empty = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 12px;
  color: var(--nd-text-disabled);
  letter-spacing: 0.04em;
`;

const ColWrap = styled(Col)`
  margin-bottom: 20px;
  display: flex;
`;

const OpeningsList = () => {
  const open = (openingsData.openings || []).filter((o) => o.status === "open");
  return (
    <Section>
      <Container>
        <Kicker>OPEN POSITIONS</Kicker>
        <Heading>Roles we are hiring for right now</Heading>
        <Sub>
          Each role is tied to an active client engagement. Click through for
          the project context, tech stack, and the LinkedIn job post.
        </Sub>
        {open.length === 0 ? (
          <Empty>No open positions this week. Check back soon.</Empty>
        ) : (
          <Row>
            {open.map((o) => (
              <ColWrap xs="12" md="6" lg="4" key={o.id}>
                <OpeningCard opening={o} />
              </ColWrap>
            ))}
          </Row>
        )}
      </Container>
    </Section>
  );
};

export default OpeningsList;
